import React from "react";
import { useEffect, useRef } from "react";
import groupBy from "lodash/groupBy";
import api from "../../utils/api";
import { useState } from "react";
import { toast } from "react-toastify";
import Spinner from "../../common/Spinner/Spinner";
import ServiceRequestList from "../../components/ServiceRequests/Handholder/ServiceRequestList";
import MyServiceRequestsFilterSection from "../../components/ServiceRequests/Handholder/MyServiceRequestsFilterSection";
import MyServiceRequestsFilterModal from "../../components/ServiceRequests/Handholder/MyServiceRequestsFilterModal";
import ServiceRequestDetailsModal from "../../components/ServiceRequests/Handholder/ServiceRequestDetailsModal";
import MyServiceRequestsDetailsModal from "../../components/ServiceRequests/Handholder/MyServiceRequestsDetailsModal";
import NotesTrailModal from "../../components/ServiceRequests/Handholder/NotesTrailModal";
import ViewAllNotesModal from "../../components/ServiceRequests/Handholder/ViewAllNotesModal";
import SMSTrailModal from "../../components/ServiceRequests/Handholder/SMSTrailModal";
import ViewAllSMSLogModel from "../../components/ServiceRequests/Handholder/ViewAllSMSLogModel";
import LPMStatusLogModel from "../../components/ServiceRequests/Handholder/LPMStatusLogModel";
import UserProfileModal from "../../components/ServiceRequests/Handholder/UserProfileModal";
import ConfirmUnsavedDataModal from "../../components/ServiceRequests/Handholder/ConfirmUnsavedDataModal";
import CancellationReasonModal from "../../components/ServiceRequests/Handholder/CancellationReasonModal";
import SendNeftDetails from "../../components/ServiceRequests/Handholder/SendNeftDetails";
import Modal from "react-modal";
import ModalContent from "../../common/Modal/ModalContent";
import close_modal from "../../assets/ic_close_wh.svg"

export default function MyServiceRequestsContainerNew(props) {
	const [isLoading, setIsLoading] = useState(false);
	const [serviceRequestList, setServiceRequestList] = useState([]);
	const [serviceRequestCount, setServiceRequestCount] = useState(0);
	const [serviceRequestHandledTodayCount, setServiceRequestHandledTodayCount] = useState(0);
	const [selectedServiceRequest, setSelectedServiceRequest] = useState({});
	const [showServiceRequestModal, setServiceRequestModalVisibility] = useState(false);
	const [isCurrentTabVisible, setisCurrentTabVisible] = useState(true);
	const [masterServiceRequestStates, setMasterServiceRequestStates] = useState([]);
	const [serviceRequestEditableData, setServiceRequestEditableData] = useState({});
	const [catalogueByServiceRequest, setCatalogueByServiceRequest] = useState([]);
	const [isLoadingInModal, setLoadingInModal] = useState(false);
	const [isUnsavedData, setisUnsavedData] = useState(false);
	const [isAllFieldsArevallid, setisAllFieldsArevallid] = useState(false);

	const [showViewAllNotesModal, setShowViewAllNotesModal] = useState(false);
	const toggleViewAllNotesModal = () => {
		setShowViewAllNotesModal(!showViewAllNotesModal);
	};
	let selectedOfflineMeet = "Not Opted";
	const [showNotesTrailModal, setShowNotesTrailModal] = useState(false);
	const toggleNotesTrailModal = () => { setShowNotesTrailModal(!showNotesTrailModal); };

	const [showStatusLogModal, setShowStatusLogModal] = useState(false);
	const toggleStatusLogModal = () => { setShowStatusLogModal(!showStatusLogModal); };

	const [showSMSTrailModal, setShowSMSTrailModal] = useState(false);
	const toggleSMSTrailModal = () => {
		setShowSMSTrailModal(!showSMSTrailModal);
	};

	const [showViewAllSMSModal, setShowViewAllSMSModal] = useState(false);
	const toggleViewAllSMSModal = () => {
		setShowViewAllSMSModal(!showViewAllSMSModal);
	};

	const [showServiceProgressionModal, setshowServiceProgressionModal] = useState(false);
	const toggleServiceProgressionModal = () => {
		setshowServiceProgressionModal(!showServiceProgressionModal);
	};

	/**CancellationReason */

	const [showCancellationReasonModal, setShowCancellationReasonModal,] = useState(false);
	const [confirmCancelModal, setConfirmCancelModal] = useState(false)

	const toggleCancellationReasonModal = () => {
		setShowCancellationReasonModal(!showCancellationReasonModal);
	};

	const openConfirmCancelModalisTrue = () => {
		setConfirmCancelModal(true)
	}

	const openConfirmCancelModalisFalse = () => {
		setConfirmCancelModal(false)
	}

	const [showUnsavedDataModal, setshowUnsavedDataModalModal,] = useState(false);
	const toggleUnsavedDataModal = () => { setshowUnsavedDataModalModal(!showUnsavedDataModal); };

	const [showConfirmationModal, setShowConfirmationModal,] = useState(false);
	const toggleConfirmationModal = () => { setShowConfirmationModal(!showConfirmationModal); }
	const [cancellationReasonDropdownOptions, setCancellationReasonDropdownOptions,] = useState();
	const [selectedCancellationReason, setSelectedCancellationReason,] = useState();
	const [enableOtherDescriptionTextbox, setEnableOtherDescriptionTextbox,] = useState(false);
	const [cancellationReasonOtherDescription, setCancellationReasonOtherDescription,] = useState();
	const [enableCancelButtonFlag, setEnableCancelButtonFlag] = useState("disable");
	const [packageTotalAmount, setPackageTotalAmount] = useState(0);
	const [isMovedToSPM, setIsMovedToSPM] = useState(false);

	const [fromNum, setFromNum] = useState(0);
	const [toNum, setToNum] = useState(49);
	const [isLoadingMore, setIsLoadingMore] = useState(false);
	const [initialDataLoaded, setInitialDataLoaded] = useState(false);

	const [newServiceRequestId, setNewServiceRequestId] = useState()

	const bottomRef = useRef(null);
	const observerRef = useRef(null);


	// const handleIntersection = (entries) => {
	// 	const [entry] = entries;
	// 	if (entry.isIntersecting && initialDataLoaded) {
	// 	  getMyServiceRequests();
	// 	}
	//   };

//   useEffect(() => {
//     observerRef.current = new IntersectionObserver(handleIntersection, {
//       root: null,
//       rootMargin: '0px',
//       threshold: 1.0, 
//     });

//     if (bottomRef.current && initialDataLoaded) {
// 		observerRef.current.observe(bottomRef.current);
//     }

//     return () => {
// 		observerRef.current.disconnect();
//     };
//   }, [fromNum, toNum, initialDataLoaded]);
	

	useEffect(() => {
		enableCancelButton();
	}, [selectedCancellationReason, cancellationReasonOtherDescription]);

	const enableCancelButton = () => {
		if (selectedCancellationReason) {
			if (selectedCancellationReason.value === "Other") {
				if (
					cancellationReasonOtherDescription &&
					cancellationReasonOtherDescription.length > 0
				) {
					setEnableCancelButtonFlag("");
				} else setEnableCancelButtonFlag("disable");
			} else setEnableCancelButtonFlag("");
		} else setEnableCancelButtonFlag("disable");
	};

	/*catalogue modal data*/
	const [showCatalogueModal, setCatalogueModalVisibility] = useState(false);
	const [selectedCatalogue, setSelectedCatalogue] = useState(null);
	const [catalogueMode, setCatalogueMode] = useState("");

	/*NEFT modal data*/
	const [showNeftModal, setNeftModalVisibility] = useState(false);
	const [neftDetails, setNeftDetails] = useState({});

	/*User profile modal data*/
	const [showUserProfileModal, setUserProfileModalVisibility] = useState(false);
	const [userProfileInitData, setUserProfileInitData] = useState({});
	const [userProfileEditableData, setUserProfileEditableData] = useState({});

	const [callButtonColor, setCallButtonColor] = useState("red");
	const [nUserId, setUserId] = useState(false);
	const [showSendNeftDetailsModal, onSetShowSendNeftDetailsModal] = useState(false);
	const [neftPaymentDetails, onSetNeftPaymentDetails] = useState({});
	const [nResourceInstanceId, setnResourceInstanceId] = useState();

	const [customerProfileData, setCustomerProfileData] = useState();
	const [DNDDate, setDNDDate] = useState();

	const [currentServiceRequestIndex, setCurrentServiceRequestIndex,] = useState(0);


	/*Service Filter logic change states*/
	const [showFilterModal, setshowFilterModal] = useState(false);
	const toggleFilterModal = () => { setshowFilterModal(!showFilterModal); }
	const [selectedServiceStatusListForFilter, setSelectedServiceStatusListForFilter] = useState([]);
	const [serviceStatusNameListForFilter, setServiceStatusNameListForFilter] = useState([]);
	const [serviceNameListForFilter, setServiceNameListForFilter] = useState([]);
	const [selectedServiceNameListForFilter, setSelectedServiceNameListForFilter] = useState([]);
	const [followUpDateTo, setFollowUpDateTo] = useState("");
	const [followUpDateFrom, setFollowUpDateFrom] = useState("");
	const [nResourceInstanceIdForUserProfileLPM, setnResourceInstanceIdForUserProfileLPM] = useState();

	const [ServiceHandeledStatusOptions, setServiceHandeledStatusOptions,] = useState([
		{
			value: "yes",
			label: "Yes",
		},
		{
			value: "no",
			label: "No",
		},
	]);
	const [selectedServiceHandeledStatus, setselectedServiceHandeledStatus] = useState(null);
	/*Service Filter logic change states end*/

	/*Need to talk to SP*/
	const [needToTalkToSPOptions, setneedToTalkToSPOptions] = useState([

		{
			value: true,
			label: "Yes",
		},
		{
			value: false,
			label: "No",
		},
		{
			value: null,
			label: "Select",
		},

	]);
	const [selectedNeedToTalkToSPOption, setSelectedNeedToTalkToSPOption,] = useState({
		value: null,
		label: "Select",
	});



	const [offlinemeetPOptions, setofflinemeetPOptions] = useState([

		{
			value: true,
			label: "Opted",
		},
		{
			value: false,
			label: "Not Opted",
		},
		{
			value: null,
			label: "Select",
		},

	]);

	const [selectedofflinemeetPOptions, setselectedofflinemeetPOptions,] = useState({
		value: null,
		label: "Select",
	});


	// const onOfflineMeetOptionChange = (option,service) => {
	//     if(option)
	//     {
	//         const updated = { ...selectedServiceRequest, 
	//             bOfflineMeet: option.value,
	//         };
	//         setSelectedServiceRequest(updated);
	//     }
	//     else{
	//         const updated = { ...selectedServiceRequest, 
	//             bOfflineMeet:null
	//         };
	//         setSelectedServiceRequest(updated);
	//     }
	// };

	const onOfflineMeetOptionChange = async (e) => {
		setselectedofflinemeetPOptions(e.value);
	};









	useEffect(() => {
		/**
		 * fetch master list of all handholders in the system
		 */
		api.getDisableFalseServiceRequestsNames({
			bDisableService: false
		}).then(({ data }) => {
			const serviceReqNamesForFilter = Object.keys(data).map((idx) => {
				return {
					label: data[idx].sServiceName,
					id: data[idx].id,
					value: data[idx].sServiceCode,
				};
			});
			setServiceNameListForFilter(serviceReqNamesForFilter);
		});

		api.getAllServiceRequestsStatus().then(({ data }) => {

			const serviceStatus = Object.keys(data).map((idx) => {
				return {
					label: data[idx].sSRState,
					value: data[idx].sSRState,
					id: data[idx].sSRState,
				};
			});
			setServiceStatusNameListForFilter(serviceStatus);
		});
	}, []);

	const setShowSendNeftDetailsModal = (data, nResourceInstanceId) => {
		onSetShowSendNeftDetailsModal(data);
		setnResourceInstanceId(nResourceInstanceId);
		if (data) {
			api.getNeftAccountDetails().then(({ data }) => {
				onSetNeftPaymentDetails(data);
			});
		}
	};

	const onClickSendNeftAccountDetails = () => {
		api.sendNeftAccountDetails({
			sEmailAddress: selectedServiceRequest["sEmailAddress"],
			nResourceInstanceId: nResourceInstanceId,
		})
			.then(({ data }) => {
				onSetShowSendNeftDetailsModal(false);
				toast(data["details"], {
					autoClose: 3000,
					type: toast.TYPE.SUCCESS,
				});
			})
			.catch((e) => {
				onSetShowSendNeftDetailsModal(true);
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 3000,
					type: toast.TYPE.ERROR,
				});
			});
	};

	// User has switched back to the tab
	const onFocus = () => {
		setisCurrentTabVisible(true);
	};

	// User has switched away from the tab (AKA tab is hidden)
	const onBlur = () => {
		setisCurrentTabVisible(false);
	};

	useEffect(() => {
		window.addEventListener('focus', onFocus);
		window.addEventListener('blur', onBlur);
		// Specify how to clean up after this effect:
		return () => {
			window.removeEventListener('focus', onFocus);
			window.removeEventListener('blur', onBlur);
		};
	});

	useEffect(() => {
		const interval = setInterval(() => {
			getMyServiceRequestsForInterval();

		}, 40000);
		return () => clearInterval(interval);
	}, [isCurrentTabVisible, selectedServiceNameListForFilter,
		selectedServiceStatusListForFilter, followUpDateFrom, followUpDateTo,
		selectedServiceHandeledStatus,fromNum, toNum]
	);

	useEffect(() => {
		getMyServiceRequests();
		setIsLoading(true);
		api.getMasterServiceRequestStates().then(({ data }) => {
			// const cancelledRemoved = data.filter((state) => {
			// 	if (state.sSRState === "Cancelled") return false;
			// 	return true;
			// });
			// const i = findIndex(data,{sSRState:"Prepared"});
			// insert(data,i,{id:"SEND_PAYMENT_CTA",sSRSState:"Send Payment Link"})
			// data.filter((state) => {
			//   if(state)
			// })
			setMasterServiceRequestStates(data);
		});
		const { temp } = api.getCancellationReasons().then(({ data }) => {
			console.log("cancellationRason", data);
			let temp1 = data.map((e) => {
				return { value: e.sReason, label: e.sReason };
			});
			setCancellationReasonDropdownOptions(temp1);
		});
		setIsLoading(false);
	}, []);

	const calculateEnableOtherDescriptionTextbox = () => {
		if (selectedCancellationReason && selectedCancellationReason.value === "Other") {
			setEnableOtherDescriptionTextbox(true);
		}
		else {
			setEnableOtherDescriptionTextbox(false);
		}
	};

	useEffect(() => {
		calculateEnableOtherDescriptionTextbox();
	}, [selectedCancellationReason]);

	useEffect(() => {
		setSelectedCancellationReason();
		setCancellationReasonOtherDescription();
		if (selectedServiceRequest && cancellationReasonDropdownOptions) {
			let temp = cancellationReasonDropdownOptions.map((e) => {
				if (e.value === selectedServiceRequest.sCancellationReason) {
					setSelectedCancellationReason(e);
					if (e.value === "Other") {
						setCancellationReasonOtherDescription(
							selectedServiceRequest.sCancellationReasonOtherDescription
						);
					}
				}
			});
		}

		// setSelectedCancellationReason();
	}, [selectedServiceRequest]);

	useEffect(() => {
		const {
			sServiceCode,
			sCatalogueId,
			sNEFTDetails,
			sNEFTTxnId_1,
			fAmountReceived_1,
			bNEFTPayment,
			nUserId,
		} = selectedServiceRequest;
		setUserId(nUserId);
		if (sServiceCode) getCatalogue(sServiceCode);
		if (sCatalogueId && sCatalogueId.length > 0) {
			setSelectedCatalogue(sCatalogueId);
		}
		if (bNEFTPayment) {
			setNeftDetails({
				sNEFTDetails,
				bNEFTPayment,
				sNEFTTxnId_1,
				fAmountReceived_1,
			});
		} else {
			setNeftDetails({});
		}

		if (
			selectedServiceRequest.nUserId ||
			selectedServiceRequest.sEmailAddress
		) {
			// api.getUserProfileData({
			// 	nUserId: selectedServiceRequest.nUserId,
			// 	sEmailAddress: selectedServiceRequest.sEmailAddress,
			// }).then(({ data }) => {
			// 	const { customer_profile_data } = data;
			// 	setCustomerProfileData(customer_profile_data);
			// });
		}
		if (
			selectedServiceRequest.sEmailAddress
		) {
			api.getDNDDate({
				sEmailAddress: selectedServiceRequest.sEmailAddress,
			}).then(({ data }) => {
				const { dnd_date } = data;
				setDNDDate(dnd_date);
			}).catch(err => {
				console.log("ERROR: error getting DND date");
				
			})
		}

		//selectedNeedToTalkToSPOption.value = "Select";
		/*if(!selectedServiceRequest.bNeedToTalkToSP)
		{
			setSelectedNeedToTalkToSPOption({
				value: false,
				label: "No",				
			})
		}
		else if(selectedServiceRequest.bNeedToTalkToSP)
		{
			setSelectedNeedToTalkToSPOption({
				value: true,
				label: "Yes",
			})
		}
		else
		{
			setSelectedNeedToTalkToSPOption({
				value: "Select",
				label: "Select",
			})
		}*/

	}, [selectedServiceRequest]);

	const getMyServiceRequests = () => {
		// if (isLoadingMore) {
		//   return;
		// }
	  
		setIsLoading(true);
	  
		let serviceRequestListtemp2 = [];
		selectedServiceNameListForFilter.map((e) => {
		  if (e.value !== "*") {
			serviceRequestListtemp2.push(e.value);
		  }
		});
		const serviceRequestList = serviceRequestListtemp2;
	  
		let servicestatusListtemp2 = [];
		selectedServiceStatusListForFilter.map((e) => {
		  if (e.value !== "*") {
			servicestatusListtemp2.push(e.value);
		  }
		});
		const statusList = servicestatusListtemp2;
		const fromDate = followUpDateFrom;
		const toDate = adjustedToDate(followUpDateTo);
		const ServiceHandeledStatus = selectedServiceHandeledStatus;
		api.getMyServiceRequestNew(
            ServiceHandeledStatus, serviceRequestList, statusList, fromDate, toDate
		).then(({ data }) => {
            if(!data.message){
                const results = data.data.map((x) => {
                    x.sEmailAddress = x.sEmailAddress.toLowerCase();
                    return x;
                });
                const groupedByCustomerEmail = groupBy(results, "sEmailAddress");
                setServiceRequestList(groupedByCustomerEmail);
                setServiceRequestCount(results.length);
                let today = new Date();
                let temp = results.filter(
                    (e) =>
                        new Date(e.dtLastHandled).getDate() === today.getDate() &&
                        new Date(e.dtLastHandled).getMonth() === today.getMonth() &&
                        new Date(e.dtLastHandled).getFullYear() === today.getFullYear()
                );
                setServiceRequestHandledTodayCount(temp.length);
            }
        //   else {
		// 	observerRef.current.disconnect()
		//   }
		});
	  
		setIsLoading(false);
	  };
	  

	const getMyServiceRequestsForInterval = () => {
		if (isCurrentTabVisible) {
			let serviceRequestListtemp2 = [];
			selectedServiceNameListForFilter.map((e) => {
				if (e.value != "*") {
					serviceRequestListtemp2.push(e.value);
				}
			});
			const serviceRequestList = serviceRequestListtemp2

			let servicestatusListtemp2 = [];
			selectedServiceStatusListForFilter.map((e) => {
				if (e.value != "*") {
					servicestatusListtemp2.push(e.value);
				}
			});
			const statusList = servicestatusListtemp2;
			const fromDate = followUpDateFrom;
			const toDate = adjustedToDate(followUpDateTo);
			const ServiceHandeledStatus = selectedServiceHandeledStatus;
			//document.title= 'Call Made With Server';
			api.getMyServiceRequestNew
				(
					ServiceHandeledStatus, serviceRequestList, statusList, fromDate, toDate
				).then(({ data }) => {
					if(!data.message){
						const results = data.data.map((x) => {
							x.sEmailAddress = x.sEmailAddress.toLowerCase();
							return x;
						});
						const groupedByCustomerEmail = groupBy(results, "sEmailAddress");
						setServiceRequestList(groupedByCustomerEmail);
						setServiceRequestCount(results.length);
						let today = new Date();
						let temp = results.filter(
							(e) =>
								new Date(e.dtLastHandled).getDate() === today.getDate() &&
								new Date(e.dtLastHandled).getMonth() === today.getMonth() &&
								new Date(e.dtLastHandled).getFullYear() === today.getFullYear()
						);
						setServiceRequestHandledTodayCount(temp.length);
					}
					else {
						toast("No Requests for this filter", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
					
				});
		}
		else {
			//document.title= 'Call Failed';
		}
	};

	const handleClickPackage = async (serviceRequest) => {
		let totalPackageOfferAmount = 0;
	  
		if (serviceRequest && serviceRequest.length > 0) {
		  try {
			const responses = await Promise.all(
			  serviceRequest.map((item) =>
				api.getServiceMoreDetails(item.nResourceInstanceId)
			  )
			);
	  
			responses.forEach(({ data }) => {
			//   const offerValue = data?.data?.[0]?.fPackageOfferAmount;
			//   if (offerValue !== undefined && offerValue !== null) {
			// 	totalPackageOfferAmount += Number(offerValue);
			//   }
				const discount = data?.data?.[0]?.fDiscountAmount || 0;
				const packageOffer = data?.data?.[0]?.fPackageOfferTotalServiceCharge || data?.data?.[0]?.fPackageOfferAmount;

				if (packageOffer !== undefined && packageOffer !== null) {
					let offerValue = 0;
					if( data?.data?.[0]?.sPackageOfferTitle === 'Long Term Engagement Package' || data?.data?.[0]?.sPackageOfferTitle === 'Long Term Engagement Package1'){
						offerValue = getServiceCostAmountAfterDiscountLongTerm(packageOffer, discount);
					}else{
						offerValue = getServiceCostAmountAfterDiscount(packageOffer, discount);
					}
					// const offerValue = getServiceCostAmountAfterDiscount(packageOffer, discount);
					totalPackageOfferAmount += Number(offerValue);
				}
			});
	  	  
			setPackageTotalAmount(totalPackageOfferAmount);
	  
			return totalPackageOfferAmount;
	  
		  } catch (error) {
			console.error("Error fetching package offer amount:", error);
			setPackageTotalAmount(0);
			return 0;
		  }
		}
	  
		setPackageTotalAmount(0);
		return 0;
	  };

	const handleServiceRequestClick = (serviceRequest) => {
        api.getServiceMoreDetails(serviceRequest)
        .then(({data}) => {
            console.log("MyDATA",data.data[0])
            if (data.data[0]["bOfflineMeet"] == true) {
                setselectedofflinemeetPOptions({
                    value: true,
                    label: "Opted",
                })
            }
            else if (data.data[0]["bOfflineMeet"] == false) {
                setselectedofflinemeetPOptions({
                    value: false,
                    label: "Not Opted",
                })
            }
			if (data?.data[0]?.["bMovedToSPM"] === true) {
				setIsMovedToSPM(true)
			}else{
				setIsMovedToSPM(false)
			}
            // else if(serviceRequest["select"]==null){
            // 	setselectedofflinemeetPOptions({
            // 		value: null,
            // 		label: "Select",
            // 	})
    
            // }
    
    
    
    
    
            if (data.data[0]["dtLastHandled"]) {
                setCallButtonColor("green");
            } else {
                setCallButtonColor("red");
            }
            setServiceRequestModalVisibility(true);
            setSelectedServiceRequest(data.data[0]);
        })
		// console.log(serviceRequest["bOfflineMeet"])
		
	};

	const toggleModal = () => {
		setServiceRequestEditableData({});
		setisUnsavedData(false);
		setisAllFieldsArevallid(false);
		setServiceRequestModalVisibility(!showServiceRequestModal);
		setNewServiceRequestId()
	};



	// //New 
	// 	let currentNoteIndex;
	// 		if (isEmpty(currentNote) == true && direction === "next") {
	// 			setLoadingInModal({
	// 				sFollowupNotes: "",
	// 				dtFollowupOn: followUpDate,
	// 				sNotes: "",
	// 				bHandled: false,
	// 				currentNoteIndex: -1,
	// 			});
	// 			return;
	// 		}

	// //end//

	//Offline meet api

	// const UpdateOfflineMeet = async (selectedService) => {
	// 	try
	// 	{

	// 		const {
	// 			nResourceInstanceId,
	// 			custbOfflineMeet
	// 		} = selectedService;

	// 		var bOfflineMeet=null;
	// 		if(custbOfflineMeet)
	// 		{
	// 			bOfflineMeet=custbOfflineMeet;
	// 		}

	// 		const payload = {
	// 			nResourceInstanceId,
	// 			bOfflineMeet:bOfflineMeet,
	// 		};
	// 		setIsLoading(true);
	// 		const { data: _ignore_ } = await api
	// 			.updateOfflineMeet(payload)
	// 			.then((d) => {
	// 				if (d.data) 
	// 				{
	// 					setIsLoading(false);
	// 					toast("Offline meet status updated successfully.", {
	// 						autoClose: 5000,
	// 						type: toast.TYPE.SUCCESS,
	// 					});
	// 					//setSelectedServiceForEdit();
	// 					//setSelectedSecondServiceForEdit();  
	// 					handleUpdateServiceRequest(); 
	// 				}
	// 			})
	// 			.catch((error) =>
	// 			{
	// 				setIsLoading(false);
	// 				toast(String(error.response.data.detail), {
	// 					autoClose: 5000,
	// 					type: toast.TYPE.ERROR,
	// 				});
	// 			});
	// 	} 
	// 	catch (error)
	// 	{
	// 		setIsLoading(false);
	// 	}            
	// };

	const onUpdateOfflineMeetoptions = async () => {


		const {
			nResourceInstanceId,
			custbOfflineMeet
		} = selectedServiceRequest;


		var bOfflineMeet = selectedofflinemeetPOptions.value;
		if (custbOfflineMeet) {
			bOfflineMeet = custbOfflineMeet;
		}

		const payload = {
			nResourceInstanceId,
			bOfflineMeet: bOfflineMeet,
		};

		//let bOfflineMeet=selectedofflinemeetoptions.value;	
		//const nResourceInstanceId = selectedServiceRequest;
		api.updateOfflineMeet(payload)
			.then((response) => {
				if (response.status == 202) {
					setSelectedServiceRequest({ ...selectedServiceRequest, bOfflineMeet: bOfflineMeet })
					if (response.data.message) {
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
					else {
						toast("Service updated successfully.", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
				}
				else {
					if (response.data.message) {
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
					else {
						toast("Internal server error.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
				}
				//toggleNotesModal();
				//getServices(tableInstance);				
			})
			.catch((error) => {
				toast(String(error.response.data.message), {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
	};

	//End




	const handleUpdateServiceRequest = async () => {
		const {
			sFollowupNotes,
			sNotes,
			dtFollowupOn: followUpDate,
		} = serviceRequestEditableData;
		if (!sFollowupNotes || !sNotes || !followUpDate) {
			///console.log("Check condition = "+selectedNeedToTalkToSPOption.value)
			//console.log("Check condition = "+selectedofflinemeetPOptions.value)
			toast("Please enter required fields.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		setLoadingInModal(true);
		const { nResourceInstanceId } = selectedServiceRequest;
		const dtFollowupOn = followUpDate.toISOString();
		var payload = {
			sFollowupNotes,
			sNotes,
			dtFollowupOn,
			nResourceInstanceId,
			bHandled: serviceRequestEditableData.bHandled,
			//Complete:serviceRequestEditableData.Complete,
		};

		if (selectedNeedToTalkToSPOption) {
			payload = { ...payload, bNeedToTalkToSP: selectedNeedToTalkToSPOption.value };
		}

		let bOfflineMeetnew = selectedofflinemeetPOptions.value;
		const { bOfflineMeet } = selectedServiceRequest;
		if (bOfflineMeetnew != bOfflineMeet) {
			if (bOfflineMeetnew == true || bOfflineMeetnew == false) {
				onUpdateOfflineMeetoptions();
			}

		}



		var str = payload;
		try {
			// eslint-disable-next-line
			const data = await api
				.updateServiceRequest(payload)
				.then(() => {
					getMyServiceRequests(false);
					//toggleModal();
					setServiceRequestEditableData({ sFollowupNotes: '', sNotes: '' });
					setisUnsavedData(false);
					setisAllFieldsArevallid(false);

					if (showUnsavedDataModal) {
						toggleUnsavedDataModal();
					}
					toast("Service Request handled successfully.", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				})
				.catch((error) => {
					const message = error?.data?.message;
					if(error == 'Error: Request failed with status code 400'){
					// if (message === "'NoneType' object has no attribute 'sServicePartnerEmail'") {
						toast(
							"Please assign an external service partner before changing the status of 'Need to Talk SP'.",
							{
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							}
						);
						return;
					}else{
					toast(
						error?.data?.Error ||
						error?.data?.message ||
						error.message,
						{
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						}
					);
					}
				});
		} catch (error) {
			toast("Something went wrong. Contact webadmin support.", {
			  autoClose: 5000,
			  type: toast.TYPE.ERROR,
			});
		} finally {
			setLoadingInModal(false);
		}
	};

	const handleServiceRequestModalDataChange = (name, value) => {
		const updated = { ...serviceRequestEditableData, [name]: value };
		setServiceRequestEditableData(updated);

		const {
			sFollowupNotes,
			sNotes,
			dtFollowupOn: followUpDate,
			//bHandled,
			//Complete
		} = updated;
		if (sFollowupNotes || sNotes || followUpDate) {
			setisUnsavedData(true);
			if (sFollowupNotes && sNotes && followUpDate) {
				setisAllFieldsArevallid(true);
			}
			else {
				setisAllFieldsArevallid(false);
			}
		}
		else {
			setisUnsavedData(false);
			setisAllFieldsArevallid(false);
		}
	};

	/* Service request STATE UPDATE callbacks*/
	const handleSendPaymentLink = async () => {
		try {
			setIsLoading(true);
			const { nResourceInstanceId } = selectedServiceRequest;

			const { data: { message }, } = await api.sendPaymentLink({ nResourceInstanceId });

			const { status, message: serverMessage } = message;
			if (status === "success") {
				const payload = {
					nResourceInstanceId,
					sSRState: "Partial/ Full Payment Pending",
				};
				// eslint-disable-next-line no-unused-vars
				const { data: _ignore_ } = await api.changeServiceRequestState(payload);
				const { data } = await api.getServiceRequestById(nResourceInstanceId);
				setSelectedServiceRequest(data);
				toast(`Payment link sent successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
				handleServiceRequestClick(nResourceInstanceId)
			}else if (status === "error" && serverMessage === "Updating LS record failed" || serverMessage === "Payment link is active. But, error in updating details to LS" || serverMessage === "'data'") {
				const payload = {
					nResourceInstanceId,
					sSRState: "Partial/ Full Payment Pending",
				};
				// eslint-disable-next-line no-unused-vars
				const { data: _ignore_ } = await api.changeServiceRequestState(payload);
				const { data } = await api.getServiceRequestById(nResourceInstanceId);
				setSelectedServiceRequest(data);
				toast(`Payment link sent successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
				handleServiceRequestClick(nResourceInstanceId)
			}
			else {
				toast(`${serverMessage}`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				//show error and message
			}
		}
		catch (error) {
			toast(`Something went wrong.Contact webadmin support.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
		finally {
			setLoadingInModal(false);
			getMyServiceRequests();
		}
		setIsLoading(false);
		setShowConfirmationModal(false);
	};

	const handleChangeState = async (state) => {
		try {
			setIsLoading(true);
			const {
				nResourceInstanceId,
				sEmailAddress,
			} = selectedServiceRequest;

			let cancellation_Reason, OtherDescription;

			if (selectedCancellationReason) {
				cancellation_Reason = selectedCancellationReason.value;
				if (cancellation_Reason !== "Other") OtherDescription = null;
				else OtherDescription = cancellationReasonOtherDescription;
			}

			const payload = {
				nResourceInstanceId,
				sSRState: state,
				cancellationReason: cancellation_Reason,
				cancellationReasonOtherDescription: OtherDescription,
			};

			// eslint-disable-next-line no-unused-vars
			// if (selectedServiceRequest?.sPaymentReceiver === "Partner" && state === "Payment Received" && (selectedServiceRequest?.refExternalServicePartner == 'Mr. Sudhir Gijare'|| selectedServiceRequest?.ext_sp_org === 'Mr. Sudhir Gijare')) {
			if (
				selectedServiceRequest?.sPaymentReceiver === "Partner" &&
				state === "Payment Received" &&
				(
					(
						selectedServiceRequest?.nPackageInstanceId === null &&
						(
							selectedServiceRequest?.refExternalServicePartner === "Mr. Sudhir Gijare" ||
							selectedServiceRequest?.ext_sp_org === "Mr. Sudhir Gijare"
						)
					) ||
					(
						selectedServiceRequest?.nPackageInstanceId !== null &&
						(selectedServiceRequest?.sPackageOfferTitle === "Long Term Engagement Package" || selectedServiceRequest?.sPackageOfferTitle === "Long Term Engagement Package1") &&
						(
							selectedServiceRequest?.refExternalServicePartner === "Mr. Sudhir Gijare" ||
							selectedServiceRequest?.ext_sp_org === "Mr. Sudhir Gijare"
						)
					) ||
					(
						selectedServiceRequest?.nPackageInstanceId !== null &&
						(selectedServiceRequest?.sPackageOfferTitle !== "Long Term Engagement Package" || selectedServiceRequest?.sPackageOfferTitle !== "Long Term Engagement Package")
					)
				)
			) {
				const response = await api.getServiceMoreDetails(
					selectedServiceRequest?.nResourceInstanceId
				);
				const serviceDetails = response?.data?.data?.[0];
				const isPaymentAvailable =
					serviceDetails?.sPaymentStatus === "Payment Link Deactivated" ||
					serviceDetails?.sPaymentStatus === "Credit" ||
					!!serviceDetails?.sNEFTDetails ||
					!!serviceDetails?.sNEFTTxnId_1 ||
					serviceDetails?.bNEFTPayment === true;

				if (!isPaymentAvailable) {
					toast(`NEFT Id or Instamojo Id should be available.`, {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
					return;
				}
			}
			const { data: _ignore_ } = await api
				.changeServiceRequestState(payload)
				.then((d) => {
					if (d.data) {
						// if (d.data["SR"]["bMovedToSPM"] === true) {
						if (
							d?.data?.SR?.bMovedToSPM === true ||
							d?.data?.message === "Service Moved To SPM"
						) {
							toast(`Moved to SPM`, {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							getMyServiceRequests(false);
							setIsMovedToSPM(true)
						}
						else if (d.data["SR"]["refSRState"] === "Cancelled") {
							toggleCancellationReasonModal();
							toast(`Service request cancelled successfully.`, {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							api.deleteExpertAppointment({
								id: localStorage.getItem("APPID")
							})
								.then(({ data }) => {
									// ExpertAppointmentData()
									console.log("Deleted", data)
									if (data === "Appointment Deleted Successfully.") {
										toast("Appointment Deleted Successfully.", {
											type: toast.TYPE.SUCCESS
										})
									}
								})
								getMyServiceRequests();
						}
						else {
							toast(`Service Request updated successfully.`, {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							// setFromNum(1)
							// setToNum(50)
							// getMyServiceRequests(false);
                            handleServiceRequestClick(nResourceInstanceId)
						}
						// getMyServiceRequests(true);
						
					}
				})
				.catch((error) => {
					toast(String(error.response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});

			const data = await api
				.getServiceRequestById(nResourceInstanceId)
				.then((d) => {
					return d.data;
				})
				.catch((error) => {
					toast(String(error.response.data.Error), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
			setSelectedServiceRequest(data);
			toast(`Service request updated successfully.`, {
				autoClose: 5000,
				type: toast.TYPE.SUCCESS,
			});
		}
		catch (error) {
		}
		finally {
			setLoadingInModal(false);
			getMyServiceRequests();
		}
		setIsLoading(false);
	};

	/*Catalogue callbacks */
	const togglCatalogueModal = () => {
		setCatalogueModalVisibility(!showCatalogueModal);
	};

	const getCatalogue = async (sServiceCode) => {
		try {
			const { data } = await api.getCatalogueForServiceRequest(sServiceCode);
			setCatalogueByServiceRequest(data);
			setCatalogueMode(data[0]["sMode"].split("_")[0]);
		}
		catch (error) {
			console.log(error);
		}
	};

	const saveCatalogue = async () => {
		try {
			setIsLoading(true);
			const { nResourceInstanceId } = selectedServiceRequest;
			const payload = {
				nResourceInstanceId,
				sCatalogueId: selectedCatalogue,
			};
			// eslint-disable-next-line no-unused-vars
			const { data: _ignore_ } = await api.saveCatalogueForServiceRequest(payload);
			const { data } = await api.getServiceRequestById();
			setSelectedServiceRequest(data);
			toast(`Service request updated successfully.`, {
				autoClose: 5000,
				type: toast.TYPE.SUCCESS,
			});
			togglCatalogueModal();
		}
		catch (error) {
			console.log(error);
		}
		setIsLoading(false);
	};

	/*NEFT callbacks*/
	const toggleNeftModal = () => {
		setNeftModalVisibility(!showNeftModal);
	};

	const handleNeftDetailsChanged = (name, value) => {
		if (name === "sNEFTTxnId") {
			if (/^[a-z0-9]*$/i.test(value) === false) return;
			name = name.concat("_1");
		}

		if (name === "fAmountReceived") {
			if (/^[0-9]*$/i.test(value) === false) return;
			if (value === undefined || value === "") value = 0;
			name = name.concat("_1");
		}
		const updated = { ...neftDetails, [name]: value };
		setNeftDetails(updated);
	};

	const getServiceCostAmountAfterDiscount = (originalAmount, discountAmount) => {
        const gstRate = 0.18; // 18% GST Rate
        const basePrice = originalAmount / (1 + gstRate)
        const discountedPrice = Math.round(basePrice) - Math.round(discountAmount)
        const serviceCostAfterDiscountIncludingGst = discountedPrice * 1.18
        // return serviceCostAfterDiscountIncludingGst.toFixed(2)
        return Math.round(serviceCostAfterDiscountIncludingGst)
    }
	const getServiceCostAmountAfterDiscountLongTerm = (originalAmount, discountAmount) => {
    const gstRate = 0.18;

    const basePrice = originalAmount / (1 + gstRate);
    const discountedPrice = basePrice - discountAmount;
    const serviceCostAfterDiscountIncludingGst =
        discountedPrice * (1 + gstRate);

    return Math.round(serviceCostAfterDiscountIncludingGst);
};

	const computeFinalPayableAmount = (sr) => {
		if (!sr.fDiscountAmount) return null;
	
		if ((Math.round(sr.fDiscountAmount) - Math.round(sr.fAmountFirst)) === 0) return 0;
	
		if (sr.nPackageInstanceId) {
			const base = sr.fPackageOfferAmount || sr.fPackageOfferTotalServiceCharge;
	
			if (sr.fDiscountAmount > base) return 0;
	
			if (sr.dtCouponExpiryDate) {
				const isExpired = new Date(sr.dtCouponExpiryDate) < new Date();
				return getServiceCostAmountAfterDiscount(base, sr.fDiscountAmount);
			}
	
			return getServiceCostAmountAfterDiscount(base, sr.fDiscountAmount);
		}
	
		if (sr.sPaymentMode === "2_Step_Payment") {
			if (sr.fDiscountAmount > sr.fAmountFirst) {
				return getServiceCostAmountAfterDiscount(sr.fAmountFull, sr.fDiscountAmount);
			}
	
			return sr.fAmountFirst;
		}
	
		const base = sr.fAmountFirst;
	
		if (sr.dtCouponExpiryDate) {
			const isExpired = new Date(sr.dtCouponExpiryDate) < new Date();
	
			return getServiceCostAmountAfterDiscount(base, sr.fDiscountAmount);
		}
	
		return getServiceCostAmountAfterDiscount(base, sr.fDiscountAmount);
	};

	const handleSaveNeftDetails = async () => {
		//make api call to save details.

		const {
			sNEFTDetails2,
			bNEFTPayment,
			sNEFTTxnId_1,
			fAmountReceived_1 = 0,
		} = neftDetails;

		if (
			fAmountReceived_1 === 0 &&
			sNEFTTxnId_1 &&
			sNEFTTxnId_1.length > 0
		) {
			toast(`Amount is required.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (
			(sNEFTTxnId_1 === undefined || sNEFTTxnId_1 === "") &&
			fAmountReceived_1 &&
			fAmountReceived_1.length > 0
		) {
			toast(`Transaction id is required.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		setIsLoading(true);
		const payableAmount = computeFinalPayableAmount(selectedServiceRequest);

		if(selectedServiceRequest.nPackageInstanceId == null){
		if (payableAmount!==null && Number(fAmountReceived_1) !== Number(payableAmount) && payableAmount !==0) {
			toast(`Amount received must equal payable amount: ₹${payableAmount}`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			setIsLoading(false);
			return;
		}else if (payableAmount ==null && Number(fAmountReceived_1) !== Number(selectedServiceRequest?.fAmountFirst)) {
			toast(`Amount received must equal payable amount: ₹${selectedServiceRequest?.fAmountFirst}`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			setIsLoading(false);
			return;
		}else if(payableAmount ==null && fAmountReceived_1 == 0 && selectedServiceRequest?.fAmountFirst > 0){
			toast(`Amount received cannot be 0. Payable amount is ${selectedServiceRequest?.fAmountFirst}.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			setIsLoading(false);
			return;
		}else if(payableAmount ==null && fAmountReceived_1 == 0){
			toast(`Amount received cannot be 0.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			setIsLoading(false);
			return;
		}else if (payableAmount === 0) {
			toast(`For 100% discount no amount should be received.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			setIsLoading(false);
			return;
		}
		}else{

			if (selectedServiceRequest?.fDiscountAmount > 0 && selectedServiceRequest?.fPackageOfferTotalServiceCharge > 0 && Number(fAmountReceived_1) !== Number(packageTotalAmount)) {
				toast(`Amount received must equal payable amount: ₹${packageTotalAmount}`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				setIsLoading(false);
				return;
			} else if (payableAmount!==null && Number(fAmountReceived_1) !== Number(payableAmount) && payableAmount !==0 && selectedServiceRequest?.fDiscountAmount === null) {
				toast(`Amount received must equal payable amount: ₹${payableAmount}`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				setIsLoading(false);
				return;
			}
			else if (payableAmount ==null && selectedServiceRequest?.fPackageOfferTotalServiceCharge > 0 && Number(fAmountReceived_1) !== Number(packageTotalAmount)) {
				toast(`Amount received must equal payable amount: ₹${packageTotalAmount}`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				setIsLoading(false);
				return;
			}
			else if (payableAmount ==null && selectedServiceRequest?.fPackageOfferAmount == 0 && Number(fAmountReceived_1) !== Number(selectedServiceRequest?.fAmountFirst)) {
				toast(`Amount received must equal payable amount: ₹${selectedServiceRequest?.fAmountFirst}`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				setIsLoading(false);
				return;
			}else if(payableAmount ==null && fAmountReceived_1 == 0){
				toast(`Amount received cannot be 0.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				setIsLoading(false);
				return;
			}else if (payableAmount === 0) {
				toast(`For 100% discount no amount should be received.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				setIsLoading(false);
				return;
			}

		}
		// let fAmountReceived = 0;
		// if (fAmountReceived_1 !== undefined || fAmountReceived_1 !== "")
		// 	fAmountReceived = 0;
		if ((sNEFTDetails2 && sNEFTDetails2.length > 0) || bNEFTPayment) {
			try {
				const { nResourceInstanceId } = selectedServiceRequest;
				// eslint-disable-next-line no-unused-vars
				const { data: _ignore_ } = await api.saveNeftDetails({
					sNEFTDetails: sNEFTDetails2,
					bNEFTPayment: true,
					sNEFTTxnId_1,
					fAmountReceived_1,
					nResourceInstanceId,
				});
				toast(`NEFT details updated successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});

				handleServiceRequestClick(nResourceInstanceId)
				getMyServiceRequests();
				// handleServiceRequestClick(nResourceInstanceId)
			} catch (error) {
				toast(`Something went wrong. Contact webadmin support.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			} finally {
				toggleNeftModal();
			}
		} else {
			toggleNeftModal();
		}
		setIsLoading(false);
	};

	const handleSaveNeftDetailsOld = async () => {
		//make api call to save details.

		const {
			sNEFTDetails,
			bNEFTPayment,
			sNEFTTxnId_1,
			fAmountReceived_1 = 0,
		} = neftDetails;

		if (
			fAmountReceived_1 === 0 &&
			sNEFTTxnId_1 &&
			sNEFTTxnId_1.length > 0
		) {
			toast(`Amount is required.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (
			(sNEFTTxnId_1 === undefined || sNEFTTxnId_1 === "") &&
			fAmountReceived_1 &&
			fAmountReceived_1.length > 0
		) {
			toast(`Transaction id is required.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		setIsLoading(true);
		// let fAmountReceived = 0;
		// if (fAmountReceived_1 !== undefined || fAmountReceived_1 !== "")
		// 	fAmountReceived = 0;
		if ((sNEFTDetails && sNEFTDetails.length > 0) || bNEFTPayment) {
			try {
				const { nResourceInstanceId } = selectedServiceRequest;
				// eslint-disable-next-line no-unused-vars
				const { data: _ignore_ } = await api.saveNeftDetails({
					sNEFTDetails,
					bNEFTPayment: true,
					sNEFTTxnId_1,
					fAmountReceived_1,
					nResourceInstanceId,
				});
				toast(`NEFT details updated successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
				getMyServiceRequests();
				handleServiceRequestClick(nResourceInstanceId)
			} catch (error) {
				toast(`Something went wrong. Contact webadmin support.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			} finally {
				toggleNeftModal();
			}
		} else {
			toggleNeftModal();
		}
		setIsLoading(false);
	};

	/*User Profile callbacks*/
	const toggleUserProfileModal = () => {
		setUserProfileModalVisibility(!showUserProfileModal);
	};

	const handleUserProfileDataChanged = (name, value) => {
		const updated = { ...userProfileEditableData, [name]: value };
		setUserProfileEditableData(updated);
	};

	// eslint-disable-next-line no-unused-vars
	const handleSaveUserProfileData = async () => {
		//make api call to save details.
		const { sNEFTDetails } = neftDetails;
		if (sNEFTDetails && sNEFTDetails.length > 0) {
			try {
				const { nResourceInstanceId } = selectedServiceRequest;
				// eslint-disable-next-line no-unused-vars
				const { data: _ignore_ } = await api.saveNeftDetails({
					sNEFTDetails,
					bNEFTPayment: true,
					nResourceInstanceId,
				});

				toast(`NEFT details updated successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			}
			catch (error) {
				toast(`Something went wrong.Contact webadmin support.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			}
			finally {
				toggleNeftModal();
			}
		}
		else {
			toggleNeftModal();
		}
	};

	const createUserProfile = async () => {
		try {

		}
		catch (error) {

		}
	};

	const updateSelectedServiceRequest = (data) => {
		setSelectedServiceRequest(data);
	};

	const changeSelectedServiceRequest = (direction) => {

		let currentServiceRequestIndex;
		let currentServiceRequest = serviceRequestList[selectedServiceRequest["sEmailAddress"]]
			.map((e, index) => {
				if (
					e.nResourceInstanceId ===
					selectedServiceRequest["nResourceInstanceId"]
				) {
					currentServiceRequestIndex = index;
				}
				return e;
			});

		if (direction == "previous" && currentServiceRequestIndex > 0) {
			currentServiceRequestIndex -= 1;
		}

		if (
			direction == "next" &&
			currentServiceRequestIndex <
			serviceRequestList[selectedServiceRequest["sEmailAddress"]].length - 1
		) {
			currentServiceRequestIndex += 1;
		}
		let newSelectedServiceRequest =
			serviceRequestList[selectedServiceRequest["sEmailAddress"]][
			currentServiceRequestIndex
			];

		if (newSelectedServiceRequest["dtLastHandled"]) {
			setCallButtonColor("green");
		}
		else {
			setCallButtonColor("red");
		}
		setCurrentServiceRequestIndex(currentServiceRequestIndex);
		setSelectedServiceRequest(newSelectedServiceRequest);
	};

	/* Search Filters callbacks */
	const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

	const toggleAllForFilter = () => {
		let temp = [];

		if (selectedServiceNameListForFilter.length != serviceNameListForFilter.length && selectedServiceNameListForFilter.length != (serviceNameListForFilter.length + 1)) {
			if (selectedServiceNameListForFilter.includes({ label: "All", value: "*" })) {
				temp = selectedServiceNameListForFilter;
			}
			else {
				temp = [{ label: "All", value: "*" }];
			}

			let tempSR = serviceNameListForFilter.map((e) => {
				if (!temp.includes(e)) {
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedServiceNameListForFilter(temp);
			setServiceNameListForFilter(tempSR);
		}
		else {
			setSelectedServiceNameListForFilter([]);
		}
	};

	const toggleSelectionForFilter = (e) => {
		setSelectedServiceNameListForFilter(e);
	};

	const toggleAllForServiceStatusFilter = () => {
		let temp = [];

		if (selectedServiceStatusListForFilter.length != serviceStatusNameListForFilter.length && selectedServiceStatusListForFilter.length != (serviceStatusNameListForFilter.length + 1)) {
			if (selectedServiceStatusListForFilter.includes({ label: "All", value: "*" })) {
				temp = selectedServiceStatusListForFilter;
			}
			else {
				temp = [{ label: "All", value: "*" }];
			}

			let tempSR = serviceStatusNameListForFilter.map((e) => {
				if (!temp.includes(e)) {
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedServiceStatusListForFilter(temp);
			setServiceStatusNameListForFilter(tempSR);
		}
		else {
			setSelectedServiceStatusListForFilter([]);
		}
	};

	const toggleSelectionForServiceStatusFilter = (e) => {
		setSelectedServiceStatusListForFilter(e);
	};


	const handleSearchClick = async () => {
		toggleFilterModal();
		getMyServiceRequests();
	};

	const handleClearFilterSearch = () => {
		setSelectedServiceNameListForFilter([]);
		setselectedServiceHandeledStatus(null);
		setSelectedServiceStatusListForFilter([]);
		setFollowUpDateFrom();
		setFollowUpDateTo();
		// getMyServiceRequests();
		// toggleFilterModal();
	};

	/*Search Filters callbacks end */

	const handleCreateNewServiceBtn = () => {
        try{
            let payload = {
                api_key : "82mqEyJnct4kzC8y",
                nPackageInstanceId: selectedServiceRequest.nPackageInstanceId
            }
			setLoadingInModal(true)

            const {tempCreateNew} = api.createNewServiceApi(payload)
            .then(({data}) => {
                if(data.ErrorCode === 200){
					setLoadingInModal(false)
					getMyServiceRequests()
					setNewServiceRequestId(data.data.entry_id)
                    toast(data.Message,
                        {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                } else {
					setLoadingInModal(false)
                    toast(data.Message,
                        {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
					
					let payload= {
						nResourceInstanceId : selectedServiceRequest.nResourceInstanceId,
						error_details : data.Message
					}
					
					const { tempEmailSend } = api.sendErrorEmail(payload)
					.then(({data})=> {
						console.log("EMAIL",data)
					})
				}
            })
        } catch (error) {
            console.log(error)
			setLoadingInModal(false)
        }
    } 

	const handleCloseBtnClick = () => {
		try {
			let payload = {
				nParentId: selectedServiceRequest.nPackageInstanceId
			}
			setLoadingInModal(true)

			const { tempCloseService } = api.closeService(payload)
			.then(({data}) => {
				console.log("Closed", data)
				if(data.Result === "Success") {
					getMyServiceRequests()
                    toast("Closed Service Successfully",
                        {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
					setLoadingInModal(false)
				}
			})

		} catch (error) {
			console.log(error)
			setLoadingInModal(false)
		}
	}

	const onCancelServiceRequestClick = (state) => {
		console.log("Cancel State",state)
		console.log("Id", selectedServiceRequest.nPackageInstanceId)
		if(selectedServiceRequest.nPackageInstanceId){
			openConfirmCancelModalisTrue()
		} else {
			handleChangeState("Cancelled")
		}
		
	}

	const onConfirmCancelClick = () => {
		openConfirmCancelModalisFalse()
		handleChangeState("Cancelled")
	}

	return (
		<>
			<div className={`row ${isLoading && "set-opacity"}`}>
				{isLoading && <Spinner className="center-screen" />}

				<MyServiceRequestsFilterSection
					toggleFilterModal={toggleFilterModal}
					serviceRequestCount={serviceRequestCount}
					serviceRequestHandledTodayCount={serviceRequestHandledTodayCount}
					RemainingServiceRequestCount={serviceRequestCount - serviceRequestHandledTodayCount}
				/>

				<ServiceRequestList
				bottomRef={bottomRef}
					serviceRequestList={serviceRequestList}
					onServiceRequestClick={handleServiceRequestClick}
					handleClickPackage={handleClickPackage}
					onUserProfileClick={(e) => {
						const { nUserId, sEmailAddress, nResourceInstanceId } = selectedServiceRequest;
						setSelectedServiceRequest(e);
						setUserProfileInitData(selectedServiceRequest);
						// toggleModal();
						toggleUserProfileModal();
						setnResourceInstanceIdForUserProfileLPM(nResourceInstanceId);
					}}
				/>

				{
					showServiceRequestModal &&
					(
						<MyServiceRequestsDetailsModal
							newServiceRequestId={newServiceRequestId}
							toggleUnsavedDataModal={toggleUnsavedDataModal}
							toggleCancellationReasonModal={toggleCancellationReasonModal}
							customerProfileData={customerProfileData}
							DNDDate={DNDDate}
							isLoading={isLoading}
							currentServiceRequestIndex={currentServiceRequestIndex}
							serviceRequestList={serviceRequestList}
							//service request details modal data
							onNavigationButtonClick={changeSelectedServiceRequest}
							callButtonColor={callButtonColor}
							isOpen={showServiceRequestModal}
							isLoadingInModal={isLoadingInModal}
							handleCreateNewServiceBtn={handleCreateNewServiceBtn}
							isUnsavedData={isUnsavedData}
							isAllFieldsArevallid={isAllFieldsArevallid}
							serviceRequestReadOnlyData={selectedServiceRequest}
							selectedOfflineMeet={selectedOfflineMeet}
							serviceRequestEditableData={serviceRequestEditableData}
							masterServiceRequestStates={masterServiceRequestStates}
							toggleModal={toggleModal}
							onUpdateServiceRequest={handleUpdateServiceRequest}
							onInputChange={handleServiceRequestModalDataChange}
							onSendPaymentLink={handleSendPaymentLink}
							onChangeState={handleChangeState}
							onUserProfileClick={() => {
								const { nUserId, sEmailAddress, nResourceInstanceId } = selectedServiceRequest;
								setUserProfileInitData(selectedServiceRequest);
								// toggleModal();
								toggleUserProfileModal();
								setnResourceInstanceIdForUserProfileLPM(nResourceInstanceId);
							}}
							//catalogue selection modal data
							isCatalogueModalOpen={showCatalogueModal}
							togglCatalogueModal={togglCatalogueModal}
							selectedCatalogue={selectedCatalogue}
							catalogueByServiceRequest={catalogueByServiceRequest}
							onCatalogueSelected={setSelectedCatalogue}
							catalogueMode={catalogueMode}
							onSaveCatalogue={saveCatalogue}
							//neft modal data
							isNeftModalOpen={showNeftModal}
							toggleNeftModal={toggleNeftModal}
							neftDetails={neftDetails}
							onNeftDetailsChanged={handleNeftDetailsChanged}
							onSaveNeftDetails={handleSaveNeftDetails}
							showSendNeftDetailsModal={showSendNeftDetailsModal}
							setShowSendNeftDetailsModal={setShowSendNeftDetailsModal}
							needToTalkToSPOptions={needToTalkToSPOptions}
							//selectedNeedToTalkToSPOption={selectedNeedToTalkToSPOption}
							setSelectedNeedToTalkToSPOption={setSelectedNeedToTalkToSPOption}
							toggleConfirmationModal={toggleConfirmationModal}
							showConfirmationModal={showConfirmationModal}
							toggleNotesTrailModal={toggleNotesTrailModal}
							toggleViewAllNotesModal={toggleViewAllNotesModal}
							toggleSMSTrailModal={toggleSMSTrailModal}
							toggleViewAllSMSModal={toggleViewAllSMSModal}
							toggleStatusLogModal={toggleStatusLogModal}
							toggleServiceProgressionModal={toggleServiceProgressionModal}
							showServiceProgressionModal={showServiceProgressionModal}

							offlinemeetPOptions={offlinemeetPOptions}
							setselectedofflinemeetPOptions={setselectedofflinemeetPOptions}
							//setselectedofflinemeetPOptions={(option) => {setselectedofflinemeetPOptions(option);}}

							selectedofflinemeetPOptions={selectedofflinemeetPOptions}
							onUpdateOfflineMeetoptions={onUpdateOfflineMeetoptions}
							getMyServiceRequestsForInterval={getMyServiceRequestsForInterval}
							getMyServiceRequests={getMyServiceRequests}
							handleServiceRequestClick={handleServiceRequestClick}
							handleClickPackage={handleClickPackage}
							handleCloseBtnClick={handleCloseBtnClick}

							confirmCancelModal={confirmCancelModal}
							openConfirmCancelModalisFalse={openConfirmCancelModalisTrue}
							onConfirmCancelClick={onConfirmCancelClick}
							isMovedToSPM={isMovedToSPM}
						/>
					)
				}
				{
					showNotesTrailModal && selectedServiceRequest &&
					(
						<NotesTrailModal
							isOpen={showNotesTrailModal}
							toggleModal={toggleNotesTrailModal}
							nResourceInstanceId={selectedServiceRequest.nResourceInstanceId}
						/>
					)
				}
				{
					showViewAllNotesModal && selectedServiceRequest &&
					(
						<ViewAllNotesModal
							isOpen={showViewAllNotesModal}
							toggleModal={toggleViewAllNotesModal}
							sEmailAddress={selectedServiceRequest.sEmailAddress}
						/>
					)
				}
				{
					showSMSTrailModal && selectedServiceRequest &&
					(
						<SMSTrailModal
							isOpen={showSMSTrailModal}
							toggleModal={toggleSMSTrailModal}
							nResourceInstanceId={selectedServiceRequest.nResourceInstanceId}
						/>
					)
				}
				{
					showViewAllSMSModal && selectedServiceRequest &&
					(
						<ViewAllSMSLogModel
							isOpen={showViewAllSMSModal}
							toggleModal={toggleViewAllSMSModal}
							sEmailAddress={selectedServiceRequest.sEmailAddress}
						/>
					)
				}
				{
					showStatusLogModal && selectedServiceRequest &&
					(
						<LPMStatusLogModel
							isOpen={showStatusLogModal}
							toggleModal={toggleStatusLogModal}
							nResourceInstanceId={selectedServiceRequest.nResourceInstanceId}
						/>
					)
				}
				{
					showFilterModal &&
					(
						<MyServiceRequestsFilterModal
							isOpen={showFilterModal}
							toggleModal={toggleFilterModal}

							onSearchClicked={handleSearchClick}
							onClearFilterSearch={handleClearFilterSearch}

							followUpDateTo={followUpDateTo}
							followUpDateFrom={followUpDateFrom}
							setFollowUpDateTo={setFollowUpDateTo}
							setFollowUpDateFrom={setFollowUpDateFrom}

							ServiceHandeledStatusOptions={ServiceHandeledStatusOptions}
							selectedServiceHandeledStatus={selectedServiceHandeledStatus}
							onServiceHandeledStatusChange={(option) => {
								setselectedServiceHandeledStatus(option);
							}}

							toggleAllForServiceStatusFilter={toggleAllForServiceStatusFilter}
							toggleSelectionForServiceStatusFilter={toggleSelectionForServiceStatusFilter}
							selectedServiceStatusListForFilter={selectedServiceStatusListForFilter}
							serviceStatusNameListForFilter={serviceStatusNameListForFilter}

							serviceNameListForFilter={serviceNameListForFilter}
							selectedServiceNameListForFilter={selectedServiceNameListForFilter}
							toggleAllForFilter={toggleAllForFilter}
							toggleSelectionForFilter={toggleSelectionForFilter}
						/>
					)
				}
				{
					showUserProfileModal &&
					(
						<UserProfileModal
							isOpen={showUserProfileModal}
							toggleModal={toggleUserProfileModal}
							userProfileInitData={userProfileInitData}
							userProfileEditableData={userProfileEditableData}
							onInputChange={handleUserProfileDataChanged}
							createUserProfile={createUserProfile}
							updateSelectedServiceRequest={updateSelectedServiceRequest}
							nUserId={nUserId}
							nResourceInstanceIdForUserProfileLPM={nResourceInstanceIdForUserProfileLPM}
						/>
					)
				}
				{
					showCancellationReasonModal &&
					(
						<CancellationReasonModal
						isLoading={isLoading}
							isDisabled={enableCancelButtonFlag}
							isOpen={showCancellationReasonModal}
							toggleModal={toggleCancellationReasonModal}
							cancellationReasonDropdownOptions={
								cancellationReasonDropdownOptions
							}
							onSelectCancellationReason={setSelectedCancellationReason}
							selectedCancellationReason={selectedCancellationReason}
							enableOtherDescriptionTextbox={enableOtherDescriptionTextbox}
							cancellationReasonOtherDescription={
								cancellationReasonOtherDescription
							}
							onChangeCancellationReasonOtherDescription={(value) => {
								setCancellationReasonOtherDescription(value);
							}}
							onChangeState={onCancelServiceRequestClick}

							confirmCancelModal={confirmCancelModal}
							openConfirmCancelModalisFalse={openConfirmCancelModalisFalse}
							onConfirmCancelClick={onConfirmCancelClick}
						/>
					)
				}
				{
					showUnsavedDataModal && (
						<ConfirmUnsavedDataModal
							isOpen={showUnsavedDataModal}
							toggleModal={toggleUnsavedDataModal}
							onUpdateServiceRequest={handleUpdateServiceRequest}
						></ConfirmUnsavedDataModal>
					)
				}
				{
					showSendNeftDetailsModal && (
						<SendNeftDetails
							isOpen={showSendNeftDetailsModal}
                            serviceRequestReadOnlyData={selectedServiceRequest}
							toggleModal={onSetShowSendNeftDetailsModal}
							neftPaymentDetails={neftPaymentDetails}
							// getNeftPaymentDetails={getNeftPaymentDetails}
							onClickSendNeftAccountDetails={
								onClickSendNeftAccountDetails
							}
						/>
					)
				}

				
			</div>
		</>
	);

}